export const lowResultsThreshold = 24
